import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaitaxifare() {



const cardData = {
  keyword: " Pune to Mumbai Taxi Fare ",

headingDescription:
  "Velocity Cab offers transparent and affordable Pune to Mumbai taxi fare options, making intercity travel convenient and budget‑friendly for business trips, airport transfers, family outings, and leisure journeys. With clear pricing, no hidden charges, reliable pickups, and professional drivers, our Pune to Mumbai taxi service ensures a comfortable and stress‑free ride. Choose from one‑way, round‑trip, or customizable travel plans according to your needs. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab helps you plan your travel with clarity on taxi fares and excellent service quality.",

topPlaces: [
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most famous shopping and dining streets, offering everything from fashion accessories to local handicrafts and cafés. Travelers booking an Innova Crysta on rent in Pune can comfortably reach this vibrant destination and enjoy shopping, street food, and the lively atmosphere. It is an ideal stop for families, couples, and groups exploring South Mumbai."
  },
  {
    title: "Girgaon Chowpatty",
    description: "Girgaon Chowpatty is a popular public beach known for its festive atmosphere and delicious Mumbai street food. Renting an Innova Crysta in Pune makes the road trip comfortable for families and friends planning a relaxing day by the sea. Visitors can enjoy beautiful sunsets, local snacks like pav bhaji and bhel puri, and various cultural celebrations."
  },
  {
    title: "Nehru Planetarium",
    description: "Nehru Planetarium is an educational attraction that offers fascinating astronomy shows and interactive exhibits. Travelers choosing an Innova Crysta on rent in Pune can enjoy a hassle-free drive to this destination, making it an excellent place for students, families, and science enthusiasts interested in space exploration."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a magnificent meditation monument located near Gorai in Mumbai. Visitors hiring an Innova Crysta on rent in Pune can comfortably travel to this peaceful destination to admire its grand golden dome, meditation halls, and serene surroundings. It is perfect for spiritual retreats and peaceful sightseeing."
  },
  {
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut caves situated inside Sanjay Gandhi National Park. Renting an Innova Crysta in Pune allows travelers to enjoy a smooth journey before exploring centuries-old sculptures, prayer halls, and historical carvings. The destination is ideal for history lovers, photographers, and adventure seekers."
  },
  {
    title: "Hanging Gardens",
    description: "The Hanging Gardens on Malabar Hill offer beautifully landscaped gardens with panoramic views of Marine Drive and the Arabian Sea. Travelers booking an Innova Crysta on rent in Pune can relax amidst lush greenery, enjoy peaceful walks, and capture stunning city views from one of Mumbai's most scenic locations."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Bandra-Worli Sea Link. Visitors traveling with an Innova Crysta on rent in Pune can enjoy a comfortable drive to this heritage site while exploring breathtaking sea views, photography spots, and Mumbai's rich colonial history."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a peaceful urban lake surrounded by modern buildings, gardens, and cafés. Travelers renting an Innova Crysta in Pune can enjoy a comfortable road trip before spending quality time by the lakeside, boating, dining, or simply relaxing with family and friends in a scenic environment."
  },
  {
    title: "Mahalakshmi Temple",
    description: "Mahalakshmi Temple is one of Mumbai's oldest and most revered Hindu temples dedicated to Goddess Mahalakshmi. Choosing an Innova Crysta on rent in Pune ensures a comfortable journey for pilgrims and tourists visiting this sacred temple while also exploring nearby coastal viewpoints and local markets."
  },
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the heart of Mumbai's film and television industry. Travelers hiring an Innova Crysta on rent in Pune can comfortably visit this famous attraction, where guided tours showcase movie sets, shooting locations, lush greenery, and behind-the-scenes experiences of Bollywood filmmaking."
  }
],



services: [
{
name: "Pune to Mumbai Fare by Cab",
description: "Pune to Mumbai fare by cab services provide transparent pricing for travelers planning intercity journeys between Pune and Mumbai. Passengers receive clear fare estimates based on distance, vehicle type, toll charges, and driver allowance. Vehicles are comfortable and suitable for highway travel via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow passengers to plan travel conveniently."
},
{
name: "Pune to Mumbai Taxi Charges",
description: "Pune to Mumbai taxi charges services help travelers understand the cost of cab travel between the two major cities. Transparent pricing includes vehicle selection such as sedan, SUV, and premium cars depending on passenger needs. Professional drivers ensure safe and punctual journeys through the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow easy travel planning."
},
{
name: "Taxi Fare from Pune to Mumbai Airport",
description: "Taxi fare from Pune to Mumbai Airport services provide reliable airport transportation with transparent fare details. Travelers can estimate costs for comfortable airport transfers via the Mumbai–Pune Expressway. Vehicles provide comfortable seating and luggage space suitable for airport journeys. Professional drivers ensure punctual pickup and safe travel. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Pune to Mumbai Cheap Cabs",
description: "Pune to Mumbai cheap cabs service offers budget-friendly travel options for passengers looking for economical transportation between the two cities. Vehicles provide comfortable seating and reliable highway travel at affordable rates. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow cost-effective ride reservations."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai offers reliable and comfortable transportation along the Mumbai–Pune Expressway. Well-maintained vehicles with experienced drivers ensure safe and punctual journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism trips, and family visits. Flexible booking options allow convenient ride scheduling."
},
{
name: "Best Cab Service from Pune to Mumbai Airport",
description: "Best cab service from Pune to Mumbai Airport provides dependable airport transportation for travelers heading to Mumbai Airport terminals. Comfortable vehicles offer spacious seating and luggage capacity suitable for airport journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow advance airport cab reservations."
},
{
name: "Best Mumbai Pune Cab Service",
description: "Best Mumbai Pune cab service offers reliable intercity transportation between Mumbai and Pune with comfortable vehicles and professional drivers. Vehicles are suitable for expressway travel ensuring smooth and safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travelers, tourists, and families. Flexible booking options allow easy cab reservations."
},
{
name: "Best Pune to Mumbai Cab Service",
description: "Best Pune to Mumbai cab service provides dependable transportation with experienced drivers and well-maintained vehicles. Passengers can travel comfortably via the Mumbai–Pune Expressway with punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, airport transfers, and tourism trips. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation suitable for families and small groups traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space for highway travel. Professional drivers ensure safe driving and punctual pickup services across the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for passengers seeking comfort and reliability during long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for highway journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy ride reservations."
},
{
name: "Pune to Mumbai Round Trip Cab Fare",
description: "Pune to Mumbai round trip cab fare services provide transparent pricing for travelers planning return journeys between the two cities. Vehicles are comfortable and suitable for long-distance expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient round-trip travel planning."
},
{
name: "Pune to Mumbai Shared Cab Fare",
description: "Pune to Mumbai shared cab fare services offer economical travel options for passengers willing to share rides with other travelers. Shared cab services reduce travel costs while maintaining comfortable highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from designated points in Pune. Flexible booking options allow convenient seat reservations."
},
{
name: "Pune to Mumbai Innova Crysta Taxi Fare",
description: "Pune to Mumbai Innova Crysta taxi fare services provide pricing details for premium SUV travel between Pune and Mumbai. Innova Crysta vehicles offer luxury interiors, spacious seating, and smooth ride quality ideal for highway journeys. Professional drivers ensure safe and punctual travel across the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow luxury ride reservations."
},
{
name: "Pune to Mumbai Airport Drop Innova Taxi Fare",
description: "Pune to Mumbai Airport drop Innova taxi fare services provide premium airport transportation with transparent pricing. Innova vehicles offer spacious seating and luggage space suitable for airport travel. Professional drivers ensure punctual pickup and safe driving services along the expressway. Pickup services are available from homes, hotels, offices, and railway stations across Pune. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Pune to Mumbai Ertiga Taxi Fare",
description: "Pune to Mumbai Ertiga taxi fare services provide affordable SUV transportation pricing for travelers traveling between Pune and Mumbai. The Ertiga vehicle offers comfortable seating and luggage capacity suitable for expressway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip service offers convenient return transportation for travelers planning trips between the two cities. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and family trips. Flexible booking options allow easy round-trip cab reservations."
}
],

tableData: [
["Pune to Mumbai Fare by Cab","Pune to Mumbai Taxi Charges"],
["Taxi Fare from Pune to Mumbai Airport","Pune to Mumbai Cheap Cabs"],
["Best Cab Service Pune to Mumbai","Best Cab Service from Pune to Mumbai Airport"],
["Best Mumbai Pune Cab Service","Best Pune to Mumbai Cab Service"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai Innova Cab"],
["Pune to Mumbai Round Trip Cab Fare","Pune to Mumbai Shared Cab Fare"],
["Pune to Mumbai Innova Crysta Taxi Fare","Pune to Mumbai Airport Drop Innova Taxi Fare"],
["Pune to Mumbai Ertiga Taxi Fare","Pune to Mumbai Cab Round Trip"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently operate on the Mumbai Pune Expressway. Their knowledge of traffic conditions and highway routes ensures a smooth and timely Pune to Mumbai taxi fare service for travelers."
  },
  {
    WhyChooseheading: "Affordable Taxi Fare Pricing",
    WhyChoosedescription: "Velocity Cabs offers affordable and transparent Pune to Mumbai taxi fare options. Customers receive clear fare details including toll charges and driver allowances before confirming their booking."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "Our Pune to Mumbai taxi service operates 24 hours a day. Whether you need an early morning ride, late night travel, or airport transfer, Velocity Cabs provides reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Taxis",
    WhyChoosedescription: "All taxis in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Taxi Booking",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way taxi service, round-trip bookings, airport transfers, and customized Pune to Mumbai travel plans."
  },
  {
    WhyChooseheading: "Multiple Taxi Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, individuals, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and railway stations across Pune including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, and Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Reliable Pune to Mumbai Taxi Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pune to Mumbai taxi bookings thanks to punctual drivers, comfortable vehicles, and professional intercity transportation service."
  }
]
};

const faqData = [
  { question: "What is the Pune to Mumbai taxi fare?", answer: "The Pune to Mumbai taxi fare depends on the vehicle type and travel plan. Velocity Cabs offers affordable and transparent pricing for all taxi bookings." },
  { question: "Is Pune to Mumbai taxi service available 24 hours?", answer: "Yes, Velocity Cabs provides 24/7 taxi service between Pune and Mumbai." },
  { question: "Which vehicles are available for Pune to Mumbai taxi service?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way taxi from Pune to Mumbai?", answer: "Yes, Velocity Cabs provides both one-way taxi and round-trip taxi services between Pune and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, offices, hotels, and railway stations across Pune." },
  { question: "Are all taxis air-conditioned?", answer: "Yes, all taxis provided by Velocity Cabs are fully air-conditioned for comfortable intercity travel." },
  { question: "Can I book Pune to Mumbai taxi service online?", answer: "Yes, customers can easily book Pune to Mumbai taxi service online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides direct drop services to Mumbai Airport and all major locations in Mumbai." },
  { question: "Are taxis sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Joshi",
    feedback:
      "Pune to Mumbai taxi service with Velocity Cab was very smooth and comfortable. The car was clean, well-maintained, and the long journey felt relaxing.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Patil",
    feedback:
      "The Pune to Mumbai taxi service from Velocity Cab was excellent. The ride was punctual, safe, and the overall travel experience was hassle-free.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Taxi Fare | Velocity Cabs",
  "description": "Velocity Cabs offers transparent and affordable Pune to Mumbai taxi fare with no hidden charges. Check cab prices, per km rates, and total cost for one way and round trip rides. Choose from sedan, Ertiga, Innova, and Innova Crysta for airport transfers and outstation travel with reliable and comfortable service.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "priceSpecification": {
      "@type": "PriceSpecification",
      "priceCurrency": "INR"
    }
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Pune to Mumbai Taxi Fare | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Check Pune to Mumbai taxi fare with Velocity Cabs. Affordable cab charges, per km rates, airport transfer cost, and one way or round trip pricing. Book reliable and cheapest Pune to Mumbai taxi service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaitaxifare;